module.exports = __webpack_public_path__ + "static/media/truck-icon-offline.ec1f639a.svg";